"use client";

import { PaymentPlanProps } from "@utils/damac/api";
import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import { FC, useEffect, useState } from "react";

import { getPaymentPlan } from "@/components/Checkout/actions";
import { paymentPlanViewMoreDataLayerEvent } from "@/dataLayer/dataLayer";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";

interface Props {
  inventoryID: string;
}
const PaymentPlan: FC<Props> = ({ inventoryID }) => {
  const { data: session } = useSession();
  const [paymentPlan, setPaymentPlan] = useState<PaymentPlanProps>();
  const [showAll, setShowAll] = useState<boolean>(false);
  const t = useTranslations();
  useEffect(() => {
    const fetchPaymentPlan = async () => {
      try {
        const data = await getPaymentPlan(inventoryID);
        if (data?.paymentPlan) {
          setPaymentPlan(data);
        }
      } catch (error) {
        console.error("Error fetching payment plan", error);
      }
    };

    if (inventoryID) {
      fetchPaymentPlan();
    }
  }, [inventoryID]);

  if (!paymentPlan) {
    return <></>;
  }

  return (
    <div className="md:w-12\/24 m-auto mt-xxl mb-3xl px-m md:px-0" id="payment-plan">
      <div className="text-l md:text-xl mb-l font-primary text-center uppercase">{t("title.paymentplan")}</div>
      <div className="text-center mb-xxl">
        {paymentPlan?.paymentPlan?.Payment_Term_Description__c} {paymentPlan?.paymentPlan?.Name}
      </div>
      <div className="flex items-center justify-between mt-l">
        <div className="w-full">
          <div className="w-full flex flex-row font-medium uppercase text-s border-b border-gray-20 pb-xs">
            <div className="w-8\/24">{t("label.paypmentPlan.installment")}</div>
            <div className="w-8\/24">{t("label.paypmentPlan.milestone")}</div>
            <div className="w-8\/24 text-right">{t("label.common.payment")}</div>
          </div>
          {paymentPlan?.paymentPlan?.Payment_Terms__r?.records.slice(0, 10).map((record) => (
            <div className="w-full flex flex-row font-normal  text-s border-b border-gray-20 py-xs" key={record?.Id}>
              <div className="w-8\/24">{record?.Installment__c}</div>
              <div className="w-8\/24">{record?.Milestone_Event__c}</div>
              <div className="w-8\/24 text-right">{record?.Percentage__c}%</div>
            </div>
          ))}
          {paymentPlan?.paymentPlan?.Payment_Terms__r?.records?.length > 10 && !showAll && (
            <Button
              size={ButtonSize.SMALL}
              variant={ButtonVariant.TERTIARY}
              theme={ButtonTheme.BLACK}
              customClass="font-medium !underline-offset-4 !p-0 !border-0 !capitalize !text-s !font-secondary mx-auto mt-xxl block"
              onClick={() => {
                setShowAll(true);
                paymentPlanViewMoreDataLayerEvent({
                  cta_name: "View More",
                  promotional_plan_tab: "",
                  installments: "",
                  milestone: "",
                  payment: "",
                  cta_location: `${paymentPlan?.paymentPlan?.Name || ""}`,
                  title_text: "Payment plan",
                  user_logged_in: !!session,
                  // user_id: session?.user.id || "",
                });
              }}
            >
              <div className="flex gap-xs items-center">{t("label.viewmore")}</div>
            </Button>
          )}
          {showAll &&
            paymentPlan?.paymentPlan?.Payment_Terms__r?.records
              .slice(10, paymentPlan?.paymentPlan?.Payment_Terms__r?.records?.length)
              .map((record) => (
                <div className="w-full flex flex-row font-normal  text-s border-b border-gray-20 py-xs" key={record?.Id}>
                  <div className="w-8\/24">{record?.Installment__c}</div>
                  <div className="w-8\/24">{record?.Milestone_Event__c}</div>
                  <div className="w-8\/24 text-right">{record?.Percentage__c}%</div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};
export default PaymentPlan;
